import { useEffect, useState } from 'react';
import { Button, Card, Col, Dropdown, Modal, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import { Link, useNavigate } from 'react-router-dom';
import Authenticator from '../authenticator';
import Loading from '../components/loading';
import SuccessMessage from '../components/successMessage';
import ErrorMessage from '../components/errorMessage';
import api from '../api/api';

export default function ConcretDosageList() {
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [registeredConcreteDosages, setRegisteredConcreteDosages] = useState([]);
  const [registeredConcreteDosage, setRegisteredConcreteDosage] = useState('');

  const [receiptFromConcreteDosage, setReceiptFromConcreteDosage] = useState('');

  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showCostsFromConcreteDosageModal, setShowCostsFromConcreteDosageModal] = useState(false);
  const [costs, setCosts] = useState('');

  useEffect(() => {
    getMaterials();
  }, []);

  function getMaterials() {
    getAllRegisteredConcreteDosages();
  }

  function getAllRegisteredConcreteDosages() {
    setLoading(true);
    api
      .get('/concrete-dosage', {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        console.log(returnFromApi.data);
        setRegisteredConcreteDosages(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function openModalToViewReceipt(concreteDosage) {
    setLoading(true);
    api.get(`/concrete-dosage/${concreteDosage.concreteDosageId}/receipt`, {
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then((returnFromApi) => {
      console.log(returnFromApi.data);
      setReceiptFromConcreteDosage(returnFromApi.data);
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      console.error('ops! ocorreu um erro' + err);
    });

    setShowReceiptModal(true);
  }

  function openModalToViewCosts(concreteDosage) {
    setLoading(true);
    api
      .get('/concrete-dosage/view-costs/' + concreteDosage.concreteDosageId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setCosts(returnFromApi.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error('ops! ocorreu um erro' + err);
      });

    setShowCostsFromConcreteDosageModal(true);
  }

  function deleteConcreteDosage(concreteDosage) {
    setLoading(true);
    api
      .delete('/concrete-dosage/' + concreteDosage.concreteDosageId, {
        headers: {
          Authorization: sessionStorage.getItem('token')
        }
      })
      .then((returnFromApi) => {
        setLoading(false);
        setSuccessMessage(returnFromApi.data);
        setShowSuccessMessage(true);
        getAllRegisteredConcreteDosages();
      })
      .catch((err) => {
        setLoading(false);
        setErrorMessage(returnFromApi.data);
        setShowErrorMessage(true);
        console.error('ops! ocorreu um erro' + err);
      });
  }

  function closeReceiptModal() {
    setShowReceiptModal(false);
  }

  function closeCostsFromConcreteDosageModal() {
    setShowCostsFromConcreteDosageModal(false);
  }

  function goToConcreteDosageForm() {
    navigate('/concrete-dosage/form');
  }

  function openConcreteDosage(concreteDosage) {
    navigate(`/concrete-dosage/form/${concreteDosage.concreteDosageId}`);
  }

  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Authenticator />
      <Card.Header className="position-relative">
        <div className="row flex-between-center">
          {showSuccessMessage && <SuccessMessage message={successMessage} setShow={setShowSuccessMessage} />}
          {showErrorMessage && <ErrorMessage message={errorMessage} setShow={setShowErrorMessage} />}

          <div className="col col-lg-8">
            <h5 className="mb-0 texto-negrito">Dosagens Cadastradas</h5>
          </div>
          <div className="col-12 col-sm-auto ms-auto">
            <Button variant="falcon-primary" className="me-2 mb-1" onClick={() => goToConcreteDosageForm()}>
              Cadastrar Nova Dosagem
            </Button>
          </div>
        </div>

        <Loading isToHidden={isLoading == false} />

        <div hidden={isLoading}>
          <div className="text-center" hidden={registeredConcreteDosages.length > 0}>
            <p className="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
              Nenhuma dosagem cadastrada ainda.
            </p>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="p-0" hidden={registeredConcreteDosages.length == 0}>
        <Table responsive className={`form-container ${isLoading ? 'loading' : ''}`}>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">Código</th>
              <th scope="col">Data</th>
              <th className="text-end" scope="col"></th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {registeredConcreteDosages.map((concreteDosage) => {
              return (
                <tr key={concreteDosage.concreteDosageId}>
                  <td>{concreteDosage.name}</td>
                  <td>{concreteDosage.code}</td>
                  <td>{concreteDosage.createdAt}</td>
                  <td className="text-center">
                    {concreteDosage.hasErrors && (
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        {/* Ícone de alerta com tooltip */}
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-${concreteDosage.concreteDosageId}`}>
                              {"Dosagem com inconsistência. Verifique os dados"}
                            </Tooltip>
                          }
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "#ffc107", // amarelo
                            }}
                          >
                            <ExclamationTriangleFill size={18} />
                          </span>
                        </OverlayTrigger>
                      </div>
                    )}
                  </td>

                  <td className="text-end">
                    <Dropdown className="d-inline-block ms-2">
                      <Dropdown.Toggle variant="falcon-default">Ações</Dropdown.Toggle>
                      <Dropdown.Menu className="py-2" popperConfig={{
                        strategy: 'fixed',
                        modifiers: [{ name: 'zIndex', options: { zIndex: 9999 } }],
                      }}>
                        <Dropdown.Item as={Link} onClick={() => openConcreteDosage(concreteDosage)}>
                          Visualizar Dosagem de Concreto
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} onClick={() => openModalToViewReceipt(concreteDosage)}>
                          Visualizar Receita
                        </Dropdown.Item>
                        <Dropdown.Item as={Link} onClick={() => openModalToViewCosts(concreteDosage)}>
                          Ver Custos
                        </Dropdown.Item>
                        <Dropdown.Divider as="div" />
                        <Dropdown.Item
                          as={Link}
                          onClick={() => deleteConcreteDosage(concreteDosage)}
                          className="text-danger"
                        >
                          Excluir
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>

      <Modal
        show={showReceiptModal}
        backdrop="static"
        keyboard={false}
        onHide={() => closeReceiptModal()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Receita</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            <Row>
              <Col xs={5}>Massa de Aditivo por Metro Cúbico:</Col>
              <Col>{receiptFromConcreteDosage.additiveMass}</Col>
            </Row>
            <Row>
              <Col xs={5}>Massa de Cimento:</Col>
              <Col>{receiptFromConcreteDosage.cementMass}</Col>
            </Row>
            <Row>
              <Col xs={5}>Massa Específica:</Col>
              <Col>{receiptFromConcreteDosage.specificMass}</Col>
            </Row>
            <Row>
              <Col xs={5}>Massa de Água:</Col>
              <Col>{receiptFromConcreteDosage.waterMassWithCorrectedHumidity}</Col>
            </Row>
            <Row>
              <Col xs={5}>Resistência Corrigida:</Col>
              <Col>{receiptFromConcreteDosage.concreteCorrectedResistance}</Col>
            </Row>

            {receiptFromConcreteDosage?.gravelMass?.length > 0 && (
              <>
                <hr color="#424242" size="2" />
                <h4>Britas por metro cúbico</h4>
                {receiptFromConcreteDosage?.gravelMass.map((gravel, index) => (
                  <Row key={index}>
                    <Col xs={5}>{gravel.name}</Col>
                    <Col>{gravel.quantity}</Col>
                  </Row>
                ))}
              </>
            )}

            {receiptFromConcreteDosage?.sandMass?.length > 0 && (
              <>
                <hr color="#424242" size="2" />
                <h4>Areias por metro cúbico</h4>
                {receiptFromConcreteDosage?.sandMass.map((sand, index) => (
                  <Row key={index}>
                    <Col xs={5}>{sand.name}</Col>
                    <Col>{sand.quantity}</Col>
                  </Row>
                ))}
              </>
            )}
          </>
          <hr color="#424242" size="2"></hr>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCostsFromConcreteDosageModal}
        backdrop="static"
        keyboard={false}
        onHide={() => closeCostsFromConcreteDosageModal()}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Custos da Dosagem de Concreto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table borderless size="sm" className="fs-10">
            <thead>
              <tr>
                <th>Fornecedor</th>
                <th>Material</th>
                <th className="text-end">Quantidade</th>
                <th className="text-end">Custo Unitário</th>
                <th className="text-end">Custo Total</th>
              </tr>
            </thead>
            <tbody>
              {costs?.materialsCostDTO?.map((item, index) => (
                <tr key={index}>
                  <td>{item.supplierName}</td>
                  <td>{item.materialName}</td>
                  <td className="text-end">{item.formattedQuantity}</td>
                  <td className="text-end">{item.formattedUnitCost}</td>
                  <td className="text-end fw-bold">{item.formattedTotalCost}</td>
                </tr>
              ))}
              <tr className="fw-bold border-top">
                <td colSpan={4} className="text-end">
                  Total Geral:
                </td>
                <td className="text-end">{costs.formattedTotalCost}</td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </Card>
  );
}
